export default "__VITE_ASSET__dfd712d1__"